import { formatCurrency, useWindowSize } from 'application/helpers'
import React from 'react'
import Tooltip from '../../tooltip'
import * as E from './LeaseInsuranceInfoBlockElements'
import globals from 'application/constants/globals'
import { useSelector } from 'react-redux'
import { getCurrentResolutionBreakPoint } from 'application/utils/utilityFunctions'

interface ILeaseInsuranceInfoBlockProps {
  Included: boolean
  Title: string
  TitleId: string
  Subtext: string
  TooltipText?: string
  TooltipId?: string
  MoreInfoUrl: string
  PremiumAmount: number
  PremiumId: string
  ProposalStyle?: boolean
}

export const LeaseInsuranceInfoBlock = ({
  Included,
  Title,
  TitleId,
  Subtext,
  TooltipText,
  TooltipId,
  MoreInfoUrl,
  PremiumAmount,
  PremiumId,
  ProposalStyle,
}: ILeaseInsuranceInfoBlockProps) => {
  const isDownloadingPdf = useSelector(
    (state: any) => state.downloadPdf.isDownloading
  )

  const resolutionBreakpoint = {
    nonDesktop: getCurrentResolutionBreakPoint(isDownloadingPdf),
  }

  const [width] = useWindowSize()
  const isDesktop = width >= resolutionBreakpoint.nonDesktop

  return (
    <div className="mb-3">
      <E.InsuranceBlockParentDiv>
        <img
          className="mt-1"
          src={Included ? '/images/select-icon.svg' : '/images/cross-icon.svg'}
          alt=""
        />

        <E.InsuranceBlockTextDiv>
          <E.InsuranceBlockFirstTextRow>
            <div>
              <E.AddOnInsuranceTitle bold={ProposalStyle} id={TitleId}>
                {Title}
              </E.AddOnInsuranceTitle>
              {!ProposalStyle && (
                <Tooltip header={Title} text={TooltipText} id={TooltipId} />
              )}
            </div>
            {isDesktop && Included && (
              <E.CardValue
                id={PremiumId}
                bold={ProposalStyle && globals.isBrandRS}
              >
                {formatCurrency(PremiumAmount)}
              </E.CardValue>
            )}
            {isDesktop && !Included && ProposalStyle && (
              <E.CardValue id={PremiumId} bold={true}>
                Not included
              </E.CardValue>
            )}
          </E.InsuranceBlockFirstTextRow>
          {!isDesktop && Included && (
            <E.CardValue
              id={PremiumId}
              bold={ProposalStyle && globals.isBrandRS}
              valueLeft
            >
              {formatCurrency(PremiumAmount)}
            </E.CardValue>
          )}
          {!isDesktop && !Included && ProposalStyle && (
            <E.CardValue id={PremiumId} bold={true} valueLeft>
              Not included
            </E.CardValue>
          )}
          <E.AddOnInsuranceSubText>{Subtext}</E.AddOnInsuranceSubText>
          <E.AddOnInsuranceLearnMore
            href={MoreInfoUrl}
            target="_blank"
            rel="noopener noreferrer"
            proposalStyle={ProposalStyle}
          >
            Learn more
          </E.AddOnInsuranceLearnMore>
        </E.InsuranceBlockTextDiv>
      </E.InsuranceBlockParentDiv>
    </div>
  )
}
